import React, { useContext } from 'react';
import { propsToCSS } from '../css';
import { GlobalStateContext } from '../../context/GlobalStateProvider';
import { ModelContext } from './ModelSource';
import { formatMoneyAmount } from '../../utils/formatUtils';

const formatValue = value => {

  if (value === undefined || value === 0 || isNaN(value)  )
    return '$0.00';
  return `${formatMoneyAmount(value)}`;
};

export function MoneyAmount({ path, value, ...props }) {
  const {isDesktop } = useContext(GlobalStateContext);
  const model = useContext(ModelContext);

  let amount = 0;

  if (Array.isArray(path)) {
    path.map(item => {
      return (amount += parseFloat(model.getValue(item)));
    });
  } else if (value || value === 0) {
    amount = value;
  } else {
    amount = parseFloat(model.getValue(path));
  }

  if(!isDesktop){
    props.class = [props.class,'mobile'];
  }
  return <span {...propsToCSS(props)}>{formatValue(parseFloat(amount))}</span>;
}

